// extracted by mini-css-extract-plugin
export var gc = "GiftCard1-module__gc___I_0bh";
export var img = "GiftCard1-module__img___JpAeJ";
export var badge = "GiftCard1-module__badge___M_elz";
export var logo = "GiftCard1-module__logo___Am1PV";